import type { FaireProductEntity } from "../../entity_types/product";

export const p_5wayvfmqcv: FaireProductEntity = {
  token: "p_5wayvfmqcv",
  type: "product",
  name: "Curious Elixir No. 4 Booze-Free Cocktails",
  brandToken: "b_3opsa00um8",
  brandName: "Curious Elixirs",
  imageUrl:
    "https://cdn.faire.com/fastly/7c6827c2597328659a25a9853af0076e5740d51550b1674a0c723257eab32429.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d77c4cd4aa781825406faa6c2c281695accf275478c0f63f1a2b70a61df9ed2d.jpeg",
    "https://cdn.faire.com/fastly/6efef943591623915008b6fbd92fea95560c2ced1bfb0f11d52f88963a0d8746.jpeg",
    "https://cdn.faire.com/fastly/d2f011f83df0d35b1704b7455923bd3d0acb36a1cc6d4f64a89939522b174056.jpeg",
    "https://cdn.faire.com/fastly/32ea08388ca6380d04930aeecf6c9164b4cd2790a43ba4c24a3ddfb92058fef2.png",
  ],
  priceDollars: 89.38,
  description:
    "Booze-free Blood Orange Sicilian Spritz: this Italian classic gives you a lift with American ginseng, the delicate fizz of non-alcoholic prosecco, with tulsi and turmeric to help you unwind\n\nEspecially good before a fine meal, and perfect for any social gathering where you want a better non-alcoholic option, Curious Elixir No. 4 is our booze-free spin on classic Italian aperitifs like the Aperol Spritz. This Elixir infuses the exotic citrus of blood orange and green mandarin, the light fizz of non-alcoholic prosecco, and the cooling power of American ginseng, turmeric, and holy basil (tulsi). Enjoy in a wine glass, on the rocks, or neat, garnished with an orange slice.",
  tags: [],
  msrpDollars: 178.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:46.536Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
